<template>
  <el-dialog
    v-if="dialogVisible"
    title="监管合同关闭提示"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="cancelHandler"
    append-to-body
  >
    <div class="container">
      <div style="text-align: center; margin-bottom: 20px">该合同未完成结算，是否依旧关闭</div>
      <el-form :model="formData" :rules="rulesForm" ref="ruleForm" label-width="120px">
        <el-form-item label="关闭合同原因" prop="closeReason">
          <el-select
            v-model="formData.closeReason"
            placeholder="请选择关闭合同原因"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) of superviseContractCloseReasonList"
              :label="item.label"
              :value="item.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="formData.remark"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-group">
      <el-button @click="confirmHandler">确 认</el-button>
      <el-button @click="cancelHandler" type="primary">取 消</el-button>
    </div>
    <CopyDialog ref="copyDialogRef" @refreshTable="refreshTable" />
  </el-dialog>
</template>

<script>
  import superviseContractApi from '@/api/park/superviseContract';
  import CopyDialog from './CopyDialog.vue';
  export default {
    data() {
      return {
        dialogVisible: false,
        formData: {
          closeReason: '',
          remark: '',
        },
        rulesForm: {
          closeReason: [
            { required: true, message: '关闭原因不能为空', trigger: ['change', 'blur'] },
          ],
        },
        superviseContractCloseReasonList: [],
        currentContractId: -1,
      };
    },
    methods: {
      openDialog(currentContractId = -1) {
        this.superviseContractCloseReasonList = this.dictListMap.warehouseContractCloseReason;
        this.currentContractId = currentContractId;
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      refreshTable() {
        this.cancelHandler();
        this.$emit('closeDialog');
      },
      confirmHandler() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            const { data } = await this.$axios.post(
              `${superviseContractApi.CLOSE_CONTRACT_BY_ID}`,
              {
                id: +this.currentContractId,
                ...this.formData,
              }
            );
            if (data.code == 0) {
              // this.$message.success(data.msg);
              this.$refs.copyDialogRef.openDialog(this.currentContractId);
              // this.$emit('closeDialog');
            } else {
              this.$message.error(data.msg);
            }
          } else {
            this.$message.error('补充资料');
            return false;
          }
        });
      },
    },
    components: {
      CopyDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    text-align: center;
  }
  .btn-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 30px;
  }
</style>
